import React from 'react';
import { SignupLayout, SignupVerifyEmailView } from '../components';
import { useSignupVerifyEmailViewController } from '../controllers';

const SignupVerifyEmailPage: React.FC = () => {
  const {
    code,
    changeCode,
    error,
    linkNotice,
    confirmingLink,
    linkUnavailable,
    sessionMissing,
    retryLink,
    submitting,
    resending,
    confirmCode,
    resendCode,
    goToLogin,
    startOver,
    changeEmail,
  } = useSignupVerifyEmailViewController();

  return (
    <SignupLayout>
      <SignupVerifyEmailView
        code={code}
        error={error}
        linkNotice={linkNotice}
        confirmingLink={confirmingLink}
        linkUnavailable={linkUnavailable}
        sessionMissing={sessionMissing}
        submitting={submitting}
        resending={resending}
        onCodeChange={changeCode}
        onConfirm={confirmCode}
        onResend={resendCode}
        onRetryLink={retryLink}
        onLogIn={goToLogin}
        onStartOver={startOver}
        onChangeEmail={changeEmail}
      />
    </SignupLayout>
  );
};

export default SignupVerifyEmailPage;
